module.exports = __webpack_public_path__ + "img/kw.841518c8.svg";